/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanStatus = exports.BenefitType = exports.Action = void 0;
var Action;
(function (Action) {
    Action["UNDEFINED"] = "UNDEFINED";
    Action["REDEEM"] = "REDEEM";
    Action["CANCEL"] = "CANCEL";
    Action["MANUAL"] = "MANUAL";
})(Action = exports.Action || (exports.Action = {}));
var BenefitType;
(function (BenefitType) {
    BenefitType["UNDEFINED"] = "UNDEFINED";
    BenefitType["LIMITED"] = "LIMITED";
    BenefitType["UNLIMITED"] = "UNLIMITED";
})(BenefitType = exports.BenefitType || (exports.BenefitType = {}));
var PlanStatus;
(function (PlanStatus) {
    PlanStatus["UNDEFINED"] = "UNDEFINED";
    PlanStatus["ACTIVE"] = "ACTIVE";
    PlanStatus["ARCHIVED"] = "ARCHIVED";
})(PlanStatus = exports.PlanStatus || (exports.PlanStatus = {}));
//# sourceMappingURL=types.js.map